import React from 'react';
import { useCalendarActionsData } from '../../../../services/calendarActionsProvider';
import { useModalMethods } from '../../../../shared/packages/modalManager';
import { modalNames } from '../../../../shared/configs/modal';

const OpenAddCalendarIntervalsModal = () => {
  const {
    deskIds,
    deskId,
    deskName,
    deskNames,
    existingIntervalIds,
    targetDate,
  } = useCalendarActionsData();

  const { open } = useModalMethods();

  const text = deskId
    ? 'Добавить интервалы'
    : 'Добавить интервалы ко всем столам';

  const handleClick = () => {
    open(modalNames.addCalendarIntervals, {
      deskIds: deskId ? [deskId] : deskIds,
      deskNames: deskName ? [deskName] : deskNames,
      existingIntervalIds,
      targetDate,
    });
  };

  return <div onClick={handleClick}>{text}</div>;
};

export default OpenAddCalendarIntervalsModal;
